import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { ResourcePlanningEntity } from "../resourcePlanning";
import React from "react";
import ReactDOM from "react-dom";

export const OpenResourcePlanningMovingDialog = (entity: ResourcePlanningEntity, title: string) => {
    return new Promise<boolean>((resolve) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: any = {
            onOk: () => {
                resolve(true)
            },
            onCancel: () => {
                resolve(false);
                root.unmount();
            },
            entity: entity,
            title: title
        }
        $("body").append(targetElement);
        root.render(<ResourcePlanningMovingDialog {...props} />);
    })
}

class ResourcePlanningMovingDialog extends React.Component<{
    entity: ResourcePlanningEntity;
    title: string;
    onOk: () => void;
    onCancel: () => void;
}, {
    }>{
    private _dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    private showInMobileFieldServiceWarning = () => {
        return Helper.hasValue(this.props.entity.Datenpaket)
            && (Config.settings.movingAssignmentInMobileClientAction == 1
                || (Config.settings.movingAssignmentInMobileClientAction == 2
                    && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(this.props.entity.KennungObj?.KNr)));
    }

    private showInMobileAppWarning = () => {
        return this.props.entity.IsSendToMobileApp
            && (Config.settings.movingAssignmentInMobileClientAction == 1
                || (Config.settings.movingAssignmentInMobileClientAction == 2
                    && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(this.props.entity.KennungObj?.KNr)));
    }

    private getInMobileFieldServiceWarning = () => {
        let showWarning = this.showInMobileFieldServiceWarning();
        if (showWarning)
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobFieldService")}</div>;
        else
            return null
    }

    private getInMobileAppWarning = () => {
        let showWarning = this.showInMobileAppWarning();
        if (showWarning)
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobApp")}</div>
        else
            return null
    }

    render() {
        let showDialog = this.showInMobileFieldServiceWarning() || this.showInMobileAppWarning();

        if(!showDialog)
            this.props.onOk();

        return (<>
            <Dialog {...this._dialogProps} open={showDialog}>
                <div style={{ display: "flex", flexDirection: "column" }} >
                    {this.getInMobileFieldServiceWarning()}
                    {this.getInMobileAppWarning()}
                </div>
            </Dialog>
        </>)
    }
}